import React, { Component } from 'react';
import Table from '../components/indicators/CategoryIndicator/Index'
import WebpackerReact from 'webpacker-react';

class CategoryIndicatorsIndex extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            data: [],
            isLoaded: true,
        }
    }

    componentDidMount(){
        this.loadData();
    }

    updateStateLoad = (state) => {
        this.setState({ isLoaded: state })
    } 

    //add items
    updateData = (data) => {
        this.setState({
            data: [...this.state.data, data],
        })
    }

    //add update
    updateItem = format => {
        this.setState({
            data: this.state.data.map(item => {
            if (format.id === item.id) {
              return { ...item, 
                name: format.name,
                section_name: format.section_name,
                order_number: format.order_number,
                positions: format.positions
              }
            }
            return item;
          })
        });
    }

    loadData = () => {
        fetch(`/indicator/get_category_indicators`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
          this.setState({
            data: data.data,
            isLoaded: false
          });
        });
    }


    render() {
        return (
            <React.Fragment>
                <Table
                    updateStateLoad={this.updateStateLoad}
                    loadData={this.loadData}
                    data={this.state.data}
                    isLoaded={this.state.isLoaded}
                    updateItem={this.updateItem}
                    updateData={this.updateData}
                    estados={this.props.estados}

                    users={this.props.users}
                    positions={this.props.positions}
                    formatos={this.props.formatos}
                />
            </React.Fragment>
        );
    }
}


export default CategoryIndicatorsIndex;
WebpackerReact.setup({ CategoryIndicatorsIndex });
